<template>
  <div>
    <ReportIndex />
  </div>
</template>

<script>
import ReportIndex from './components/report'
export default {
  name: 'transport-dashboard',
  components: {
    ReportIndex,
  },
  data() {
    return {
      activeName: 'base',
    }
  },
}
</script>

<style></style>
